import {RiLoginBoxLine, RiLogoutBoxLine} from "react-icons/ri";
import {Link} from "react-router-dom";
import {LOGIN_PAGE} from "../constants/page_constants";
import {accountInfo} from "../constants/constants";

const SideBarLoginButton = ({logOut}) => {
  return (
      <>
        {/* 로그인 상태에 따라 표시 */}
        {accountInfo.isLogin() ?
            <li className="mt-auto mb-3 flex flex-row justify-center">
              <button
                  onClick={logOut}
                  className="group w-full flex p-2 text-sm font-semibold leading-6 text-white bg-red-700 justify-center rounded-md"
              >
                <RiLogoutBoxLine className="mr-3 h-6 w-6 shrink-0 text-white"/>
                로그아웃
              </button>
            </li>
            :
            <li className="mt-auto mb-3 whitespace-nowrap ">
              <Link
                  to={LOGIN_PAGE}
                  className="group w-full flex p-2 text-sm font-semibold leading-6 text-white bg-red-700 justify-center rounded-md"
              >
                <RiLoginBoxLine className="mr-3 h-6 w-6 shrink-0 text-white"/>
                로그인
              </Link>
            </li>
        }
      </>
  )
}
export default SideBarLoginButton;